<template>
  <BoardView :pagination="pagination" :title="$t('title')" :total="total">
    <BoardTable :hasResults="!!total" :isFetching="isFetching" :pagination="pagination">
      <RecordMail
        v-for="mail in results"
        :key="mail.id"
        :mail="mail" />
    </BoardTable>
    <router-view />
  </BoardView>
</template>

<script>
import RecordMail from './components/RecordMail'
import Table from '@mixins/Table'

export default {
  mixins: [
    // SheetExport,
    Table,
  ],
  components: { RecordMail },
  data() {
    return {
      paginationOptions: {
        name: 'mail',
        service: 'mail',
        searchIn: ['from', 'subject', 'to'],
        filters: [
          {
            label: 'Receiver',
            append: value => ({
              to: {
                $ilike: value,
              },
            }),
          },
          {
            label: 'Topic',
            append: value => ({
              subject: {
                $ilike: value,
              },
            }),
          },
          {
            label: 'Sent date, from',
            type: 'date',
            append: value => ({
              createdAt: {
                $gte: value,
              },
            }),
          },
          {
            label: 'Išsiuntimo data, iki',
            type: 'date',
            append: value => ({
              createdAt: {
                $lte: value,
              },
            }),
          },
        ],
      },
    }
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "title": "Email"
  }
}
</i18n>
